import React from 'react';
import {Link} from 'react-router-dom';

function Footer() {
  return (
    <div>
      <footer className="footer__1">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 space-y-20">
              <div className="footer__logo">
                <Link to="/">
                  <img src={`img/logos/meritverse.png`} alt="logo" id="logo_js_f" />
                  MeritVerse
                </Link>
              </div>
              <p className="footer__text">
                MeritVerse is based on ERC721 and ERC1155
              </p>
              <div>
                <ul className="footer__social space-x-10 mb-40">
                  <li>
                    <a href="https://www.facebook.com/" rel="noreferrer"  target="_blank">
                      <i className="ri-facebook-line" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.messenger.com/" rel="noreferrer"  target="_blank">
                      <i className="ri-messenger-line" />
                    </a>
                  </li>
                  <li>
                    <a href="https://whatsapp.com" target="_blank" rel="noreferrer" >
                      <i className="ri-whatsapp-line"  />
                    </a>
                  </li>
                  <li>
                    <a href="https://youtube.com" target="_blank" rel="noreferrer" >
                      <i className="ri-youtube-line" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2 col-6">
              <h6 className="footer__title">MeritVerse</h6>
              <ul className="footer__list">
                <li>
                  <Link to="#"> Home1 </Link>
                </li>
                <li>
                  <Link to="#"> Home2</Link>
                </li>
                <li>
                  <Link to="#"> Home3 </Link>
                </li>
                <li>
                  <Link to="#"> Marketplace</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-6">
              <h6 className="footer__title">Assets</h6>
              <ul className="footer__list">
                <li>
                  <Link to="#"> Profile </Link>
                </li>
                <li>
                  <Link to="#"> Creators </Link>
                </li>
                <li>
                  <Link to="#"> Colletctions </Link>
                </li>
                <li>
                  <Link to="#"> Activity</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-6">
              <h6 className="footer__title">Company</h6>
              <ul className="footer__list">
                <li>
                  <Link to="#"> Upload Types </Link>
                </li>
                <li>
                  <Link to="#"> Upload </Link>
                </li>
                <li>
                  <Link to="#"> Connect wallet</Link>
                </li>
                <li>
                  <Link to="#"> Item details </Link>
                </li>
              </ul>
            </div>
          </div>
          <p className="copyright text-center">
            Copyright © 2022. Created with love by MeritVerse.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
